<template>
	<v-badge small color="orange" :value="canShowBadge">
		<template v-slot:badge>
			<span>
				<v-icon small>mdi-exclamation</v-icon>
			</span>
		</template>
		<v-icon>mdi-account-group</v-icon>
	</v-badge>
</template>

<script>

export default {
	inject: ['lessonPlanController'],
	computed: {
		hasAudienceNotes() {
			return (
				this.lessonPlanController.navigation.selectedSlide.notes.audience !== '<p></p>' &&
				this.lessonPlanController.navigation.selectedSlide.notes.audience !== ''
			);
		},
		canShowBadge() {
			return this.hasAudienceNotes;
		}
	}
};
</script>
